import React from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import Login from './components/login/Login'
import Dashboard from './components/Dashboard'
import AppData from './components/AppData/AppData'
import Users from './components/users/Users'
import Manager from './components/Manager/Manager'
import Boys from './components/Boys/Boys'

export default function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" exact component={Login} />
        <Route path="/dashboard" exact component={Dashboard} />
        <Route path="/dashboard/appData" exact component={AppData} />
        <Route path="/users" exact component={Users} />
        <Route path="/managers" exact component={Manager} />
        <Route path="/boys" exact component={Boys} />
      </Switch>
    </BrowserRouter>
  )
}
